import { render, staticRenderFns } from "./abnormalData.vue?vue&type=template&id=edc85cb6&scoped=true"
import script from "./abnormalData.vue?vue&type=script&lang=js"
export * from "./abnormalData.vue?vue&type=script&lang=js"
import style0 from "./abnormalData.vue?vue&type=style&index=0&id=edc85cb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc85cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc85cb6')) {
      api.createRecord('edc85cb6', component.options)
    } else {
      api.reload('edc85cb6', component.options)
    }
    module.hot.accept("./abnormalData.vue?vue&type=template&id=edc85cb6&scoped=true", function () {
      api.rerender('edc85cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/abnormalData.vue"
export default component.exports